// extracted by mini-css-extract-plugin
module.exports = {"wrapper__0":"Subheader_wrapper__0__VbwC5","wrapper__10":"Subheader_wrapper__10__2R1cO","wrapper__12":"Subheader_wrapper__12__1vBPE","slot":"Subheader_slot__1scrq"};